import React, { useRef, useState, useEffect } from "react"
import AnchorLink from "react-anchor-link-smooth-scroll"
import { Link } from "./components"
import { backgrounds } from "polished"
import { NONAME } from "dns"

function makeid() {
  var text = ""
  var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZ"
  for (var i = 0; i < 5; i++)
    text += possible.charAt(Math.floor(Math.random() * possible.length))
  return text
}

function random_rgba() {
  var o = Math.round,
    r = Math.random,
    s = 255
  return (
    "rgba(" +
    o(r() * s) +
    "," +
    o(r() * s) +
    "," +
    o(r() * s) +
    "," +
    r().toFixed(1) +
    ")"
  )
}

const sections = [...Array(5 + Math.floor(Math.random() * 10))].map(() => ({
  label: makeid(),
  color: random_rgba(),
  height: Math.floor(Math.random() * 70) + 30
}))

export default () => {
  const [inView, setInView] = useState({
    things: false,
    stuff: false,
    ...sections.map(section => ({ [section.label]: false }))
  })
  return (
    <div style={{ padding: 20, paddingTop: 50 }}>
      <div
        style={{
          position: "fixed",
          background: "white",
          left: 0,
          right: 0,
          top: 0,
          padding: 20
        }}
      >
        {sections.map(section => (
          <AnchorLink
            offset="60"
            key={section.label}
            href={`#${section.label}`}
            style={{
              ...(inView[section.label] && { color: "white" }),
              ...(!inView[section.label] && { color: "black" }),
              margin: 10,
              textDecoration: "none",
              padding: 5,
              ...(inView[section.label] && { background: section.color }),
              transition: "color 300ms ease"
            }}
          >
            {section.label}
          </AnchorLink>
        ))}
      </div>
      {sections.map(section => (
        <Section
          key={section.label + "-section"}
          setInView={value => setInView({ ...inView, [section.label]: value })}
          id={section.label}
          style={{ background: section.color, height: `${section.height}vh` }}
        >
          {section.label}
        </Section>
      ))}
    </div>
  )
}

const Section = ({ id, setInView, style }) => {
  const ref = useRef()
  const onScreen = useOnScreen(ref)
  useEffect(() => {
    setInView(onScreen)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onScreen])
  return (
    <section
      id={id}
      style={{ height: "110vh", padding: 10, margin: 20, ...style }}
      ref={ref}
    >
      <h2 style={{ margin: 0 }}>
        {id} {onScreen && ""}
      </h2>
    </section>
  )
}

// Hook
const useOnScreen = (ref, rootMargin = "-60px") => {
  // State and setter for storing whether element is visible
  const [isIntersecting, setIntersecting] = useState(false)

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        // Update our state when observer callback fires
        setIntersecting(entry.isIntersecting)
      },
      {
        rootMargin
      }
    )
    if (ref.current) {
      observer.observe(ref.current)
    }
    return () => {
      observer.unobserve(ref.current)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []) // Empty array ensures that effect is only run on mount and unmount

  return isIntersecting
}
